import React from "react";
import { Tooltip } from "@mui/material";
import moment from "moment";
import { StyledChip, CustomIconArea, ContainerGroup, TooltipContentContainer } from "./styles";

export function ChipWithTooltip({ label, expirationDate, isSpecial, isError, isInvalid, icon, disableTooltip }) {
  if (!label || String(label).trim() === '') return null;

  const composedLabel = (
    <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2, overflow: 'hidden', maxWidth: '100%' }}>
      <Tooltip title={label} placement="top" arrow>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>{label}</span>
      </Tooltip>
      {(expirationDate && (isSpecial || isInvalid)) && (
        <span style={{ fontSize: '10px', opacity: 0.75 }}>
          {moment(expirationDate).format("DD/MM/YYYY")}
        </span>
      )}
    </span>
  );

  const chip = (
    <StyledChip
      label={composedLabel}
      isSpecial={isSpecial}
      isError={isError}
      isInvalid={isInvalid}
      icon={icon}
    />
  );
  return disableTooltip ? chip : (
    <Tooltip title={label} placement="top">
      {chip}
    </Tooltip>
  );
}

export function GroupedChipsWithTooltip({ data, getPropsObj }) {
  if (!data || data.length === 0) return null;

  return (
    <>
      {data.length > 1 ? (
        <ContainerGroup alignStart={true}>
          <ChipWithTooltip 
            {...getPropsObj(data[0], 0)}
            disableTooltip={true}
          />
          <Tooltip
            title={
              <TooltipContentContainer>
                {data.slice(1).map((el, index) => (
                  <ChipWithTooltip 
                    key={el.id ?? index} 
                    {...getPropsObj(el, index + 1)} 
                    disableTooltip={true}
                  />
                ))}
              </TooltipContentContainer>
            }
            placement="right"
          >
            <CustomIconArea>{`+${data.length - 1}`}</CustomIconArea>
          </Tooltip>
        </ContainerGroup>
      ) : (
        <ChipWithTooltip 
          {...getPropsObj(data[0], 0)}
          disableTooltip={true}
        />
      )}
    </>
  );
}
